import React from 'react'

import { store } from '../../helpers/index'
import { confirmationServices } from '../../services'
import { alertActions } from '../../actions'
import { withLocalize } from 'react-localize-redux'

class ConfirmationNeeded extends React.Component {
  constructor(props) {
    super(props)

    this.handleResendConfirmation = this.handleResendConfirmation.bind(this)
  }

  handleResendConfirmation(event) {
    const { dispatch } = store
    const token = sessionStorage.getItem('token')
    const { translate } = this.props

    confirmationServices.update(token).then(
      response => {
        dispatch(alertActions.success(translate('alert.emailSent')))
      },
      error => {
        if (error.response) {
          const errors = error.response.data.errors
          if (errors) {
            errors.forEach(e => {
              dispatch(alertActions.error(e))
            })
          }
        }
      }
    )
  }

  render() {
    const { translate } = this.props

    return (
      <div className="container mt-4 mb-4">
        <div className="row">
          <div className="col-lg-12 text-center">
            <h2 className="heading">
              {translate('confirmationNeeded.header')}
            </h2>
            <div>
              <p className="lead">
                {translate('confirmationNeeded.notConfirmed')}
              </p>
              <button
                className="btn btn-primary"
                onClick={this.handleResendConfirmation}
              >
                {translate('confirmationNeeded.resend')}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withLocalize(ConfirmationNeeded)
